module.exports = __webpack_public_path__ + "static/img/icon-eva5.3f01bbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva5.jpg
// module id = xpRL
// module chunks = 21